


















import Vue, { PropType } from 'vue'
import XRadio, { RadioProps } from './XRadio.vue'

export type OptionEntry<T = string | number | boolean> = {
  value: T
  label: string
}

export default Vue.extend({
  name: 'XRadioGroup',
  components: { XRadio },
  props: {
    options: {
      type: Array as PropType<OptionEntry[]>,
      default: () => [],
    },
    value: {
      type: [String, Number, Boolean] as PropType<RadioProps['value']>,
    },
    rules: {
      type: [String, Object],
    },
  },
  methods: {
    updateValue(value: string | number | boolean) {
      this.$emit('input', value)
    },
  },
})
